(() => {
  const replaceTag = (node, tagName) => {
    if (!node || node.tagName.toLowerCase() === tagName.toLowerCase()) return node;

    const replacement = document.createElement(tagName);
    for (const attribute of node.attributes) {
      replacement.setAttribute(attribute.name, attribute.value);
    }

    while (node.firstChild) {
      replacement.appendChild(node.firstChild);
    }

    node.replaceWith(replacement);
    return replacement;
  };

  // The homepage already has a descriptive hero H1; the logo is branding, not the page heading.
  replaceTag(document.querySelector('h1.header__logo'), 'div');

  // Upgrade the published FAQ's visual category labels to semantic H2 headings in this draft theme only.
  document.querySelectorAll('.fp-faq-cat-title').forEach((category) => {
    replaceTag(category, 'h2');
  });

  // Safety net for custom page templates: ensure a descriptive page H1 exists without duplicating an existing one.
  const pageMain = document.querySelector('main#main[data-page-title]');
  if (pageMain && !pageMain.querySelector('h1')) {
    const heading = document.createElement('h1');
    heading.className = 'sr-only';
    heading.textContent = pageMain.dataset.pageTitle;
    pageMain.prepend(heading);
  }
})();
